import { usePage } from '@/hooks'
import React from 'react'
import { Link } from 'react-router-dom'
import HtmlContent from '../HtmlContent'
import Title from '../Title'
import style from './styles/quiz.module.scss'

interface IProps {
  id: number
  image: string
  title: string
  text: string
}

const QuizCard = ({ id, image, title, text }: IProps): React.ReactElement => {
  const page = usePage()
  const { config } = page?.init_state?.global
  const urlDetail = `${config.quiz}?element_id=${id}`

  return (
    <Link to={urlDetail} className={style.quiz__link}>
      <img
        src={image}
        width='271px'
        height='233px'
        alt={title}
        className={style.quiz__image}
      />
      <div className={style.quiz__content}>
        <Title type='h3' className={style.quiz__title}>
          {title}
        </Title>
        <HtmlContent content={text} className={style.quiz__text} />
      </div>
    </Link>
  )
}

export default QuizCard
